import React from 'react';
import PropTypes from 'prop-types';
import Style from './OverlayFooter.module.scss';

const OverlayFooter = ({ language }) => {
  const {
    legalDoNotSellName,
    legalDoNotSellUrl,
    legalPrivacyName,
    legalPrivacyUrl,
    legalTermsName,
    legalTermsUrl,
  } = language;

  const formatLink = (text, url) => (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  );

  return (
    <footer className={Style.footerContainer}>
      {formatLink(legalTermsName, legalTermsUrl)} &nbsp; and &nbsp;
      {formatLink(`Updated ${legalPrivacyName}`, legalPrivacyUrl)}.&nbsp;
      {formatLink(legalDoNotSellName, legalDoNotSellUrl)}
    </footer>
  );
};

export default OverlayFooter;

OverlayFooter.propTypes = {
  language: PropTypes.shape({}).isRequired,
};
